import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { EditTrainingTypeSchema } from "../../../../utils/mainTabs/manage/createTrainingTypeSchema";
import { colors } from "../../../../utils/stripeColors";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import {
  addTrainingTypeActionHandler,
  isTrainingTypeExistsActionHandler,
} from "../../../../store/actions/actionHandlers/manageActionHandler";
import classes from "./EditTrainingTypeForm.module.scss";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { FormattedMessage, injectIntl } from "react-intl";

const EditTrainingTypeForm = ({
  editTrainingTypeId,
  handleSearchQuery,
  editTrainingTypeName,
  handleEditModal,
  intl,
}) => {
  const dispatch = useDispatch();
  const manageState = useSelector((state) => state.manageReducer);
  const { addTrainingTypeLoader } = manageState;
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;

  const [editTrainingNameExistsLoader, setEditTrainingNameExistsLoader] =
    useState(false);
  const [isEditTrainingNameExists, setIsEditTrainingNameExists] =
    useState(null);

  const editTrainingTypeMethods = useForm({
    defaultValues: { EditTrainingType: "" },
    resolver: yupResolver(EditTrainingTypeSchema),
    mode: "onChange",
  });

  const {
    handleSubmit: editTrainingTypeHandleSubmit,
    // reset: editTrainingTypeReset,
    formState: {
      isValid: isEditTrainingTypeValid,
      errors: editTrainingTypeErrors,
      isDirty: isEditTrainingTypeDirty,
    },
    setFocus,
    setValue,
  } = editTrainingTypeMethods;

  useEffect(() => {
    setValue("EditTrainingType", editTrainingTypeName);
    setFocus("EditTrainingType");
  }, [setFocus, setValue, editTrainingTypeName]);

  const handleEditTrainingNameExists = (e) => {
    let val = e.target.value.trim() !== "" && e.target.value;
    if (val && isEditTrainingTypeDirty && isEditTrainingTypeValid) {
      setEditTrainingNameExistsLoader(true);
      dispatch(isTrainingTypeExistsActionHandler(val)).then((response) => {
        if (response && response.status === 200) {
          setEditTrainingNameExistsLoader(false);
          if (response.data) {
            setIsEditTrainingNameExists(true);
          } else {
            setIsEditTrainingNameExists(false);
          }
        }
      });
    } else {
      setIsEditTrainingNameExists(false);
    }
  };

  //edit training type logic
  const onEditSubmit = (data) => {
    dispatch(
      addTrainingTypeActionHandler(
        data.EditTrainingType,
        editTrainingTypeId,
        handleSearchQuery
      )
    ).then((isEdited) => {
      if (isEdited) {
        dispatch(
          setErrorHandler(
            errorTypes.SUCCESS,
            `Training Type ${data.EditTrainingType} edited successfully`
          )
        );
        handleSearchQuery();
        handleEditModal(0);
      }
    });
  };
  return (
    <FormProvider {...editTrainingTypeMethods}>
      <form
        className={classes.editTrainingType__editModal}
        onSubmit={editTrainingTypeHandleSubmit(onEditSubmit)}
      >
        <div className={classes.editTrainingType__editModal__editField}>
          <Input
            // label={"Name"}
            name={"EditTrainingType"}
            direction="row"
            placeholder={intl.formatMessage({
              id: `ENTER_TRAINING_TYPE`,
            })}
            height="5"
            width="30"
            gap="0"
            onChange={(e) => handleEditTrainingNameExists(e)}
            loading={editTrainingNameExistsLoader}
            // error={editTrainingTypeErrors?.["EditTrainingType"]?.message}
          />
          {editTrainingTypeErrors?.EditTrainingType?.message ? (
            <div
              className={classes.editTrainingType__editModal__editField__error}
            >
              {editTrainingTypeErrors?.EditTrainingType?.message}
            </div>
          ) : (
            isEditTrainingNameExists && (
              <div
                className={
                  classes.editTrainingType__editModal__editField__error
                }
              >
                <FormattedMessage id="TRAINING_NAME_EXIST" />
              </div>
            )
          )}
        </div>
        <div className={classes.editTrainingType__editModal__footer}>
          <Button
            label={<FormattedMessage id="USERGRP_ACTIONBUTN_TEXT" />}
            backgroundColor={addTrainingTypeLoader ? undefined : colors.theme}
            borderRadius={"0.7"}
            color={addTrainingTypeLoader ? undefined : "#fff"}
            disabled={!isEditTrainingTypeValid || isEditTrainingNameExists}
            width={"14.5"}
            height={"4.9"}
            type="submit"
            loading={addTrainingTypeLoader}
          />
          <div
            className={classes.editTrainingType__editModal__footer__button2}
            onClick={() => handleEditModal(0)}
          >
            <FormattedMessage id="USERGRP_CANCELBTN_TEXT" />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default React.memo(injectIntl(EditTrainingTypeForm));
